import { MIXPANEL_EVENTS } from '../../constants';
import { useResponsesContext } from '../../context/ResponseContext';
import {
  BotMessageOptionProps,
  EOptionAction,
  OptionsProps,
} from '../../types';
import { Button } from 'ui/mobile-ds';

import React from 'react';
import { track } from '../../utils/track';
import { PromptStar } from 'ui/icons';

const BotMessageOption: React.FC<BotMessageOptionProps> = ({
  title,
  handleButtonClick,
}) => {
  return (
    <Button
      type="submit"
      onClick={handleButtonClick}
      className="rounded-lg border border-mobile-gray-100 border-[1.5px] w-fit p-3 px-4 mb-2
       mr-2 text-sm bg-white text-gray-500 font-semibold max-w-[82%] text-left hover:bg-mobile-gray-100"
    >
      <PromptStar color="#8C98AB" />
      {title}
    </Button>
  );
};

const Prompts: React.FC<OptionsProps> = ({
  options,
  setOptionClicked,
  getAnswer,
}) => {
  const { setResponses, queryIdRef, setIsAnswerLoading, variantConfig } =
    useResponsesContext();

  const handleButtonClick = async (content: string) => {
    track({
      event: MIXPANEL_EVENTS.BOT_MENU_CLICKED,
      data: {
        menuActionType: EOptionAction.BOT_BUTTON,
        menuTitle: content,
        bot: variantConfig?.variant,
      },
    });
    const queryId = queryIdRef.current++;

    //button option will get added to chat.
    setResponses((prev) => [
      ...prev,
      {
        id: queryId,
        query: content,
        response: '',
        feedbackGiven: true,
        cid: '',
        date: new Date(),
      },
    ]);
    setIsAnswerLoading(queryId);

    //hide the option div
    setOptionClicked(true);

    //run the api to get response from the API for the selected option.
    await getAnswer(content, queryId);
  };

  return (
    <div className="flex relative w-full pl-5 pt-4 bg-white overflow-x-auto flex-wrap">
      {options.map((option, index) => {
        //in future more option can be added, so using switch case
        switch (option.actionType) {
          case EOptionAction.BOT_BUTTON:
            return (
              <BotMessageOption
                key={index}
                title={option.title}
                handleButtonClick={() => handleButtonClick(option.title)}
                setOptionClicked={setOptionClicked}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};

export default Prompts;
